export default __webpack_public_path__ + "static/simple1-30cdba67ce3226c8918be7c594cc26c0.svg";